
<div class="row title">
   <h3>Dashboard / <span>Add New Apartment</span></h3>
</div>
<!-- <div class="container-fluid"> -->
<div class="row">
   <div class="col-12" style="margin-top: 4rem;" *ngIf="msgError">
     <div class="alert-box grid-100" *ngIf="errorMessage">
       <div class="alert alert-danger mt-3 text-center">
       <a class="close link" data-dismiss="alert">×</a>
       {{errorMessage}}
       </div>
     </div>
   </div>
   <div class="col-12" style="margin-top: 4rem;" *ngIf="successError">
      <div class="alert-box grid-100" *ngIf="successMessage">
        <div class="alert alert-success mt-3 text-center">
        <a class="close link" data-dismiss="alert">×</a>
        {{successMessage}}
        </div>
      </div>
    </div>
 </div>


<div class="row justify-content-center internalPageBodyContent">
   <div class="col-md-10 col-md-offset-2 mb-3">
      <!-- <button class="button button_emi" (click) = "back()"> BACK TO Apartment DATA</button> -->
      <!-- <div class="alert alert-success text-center mt-2" *ngIf="successMessage">{{successMessage}}</div>
         <div class="alert alert-danger text-center mt-2" *ngIf="errorMessage">{{errorMessage}}</div> -->
      <div class="card">
         <div class="card-content my-2 mx-2">
            <div class="tab-content">
               <div class="tab-pane active">
                  <form [formGroup]="createApartmentForm" (ngSubmit)="onSubmit(createApartmentForm.value); createApartmentForm.reset();" class="form-horizontal">
                  <!-- <fieldset formArrayName="apa"> -->
                  <div class="row">
                     <!--For Apartment Name-->   
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="control-label">Apartment Name</label>
                           <input type="text" min=0 class="form-control" placeholder="Enter Apartment Name"  formControlName="apartment_name">
                        </div>
                     </div>
                     <!--For Cluster-->   
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="control-label">Cluster</label>
                           <input type="text" min=0 class="form-control" placeholder="Enter Cluster"  formControlName="cluster">
                        </div>
                     </div>
                     <!--For Apartment Address-->   
                     <div class="col-md-12">
                        <div class="form-group label-floating" >
                           <label class="control-label">Apartment Addess</label>
                           <input type="text" min=0 class="form-control" placeholder="Enter Apartment Addess"  formControlName="apartment_address">
                        </div>
                     </div>
                     <!-- For Pin Code-->  
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="control-label">Pin Code</label>
                           <input type="number" min=0 class="form-control" placeholder="Enter Pin Code"  formControlName="pincode" onKeyPress="if(this.value.length==6) return false;" pattern="[0-9]{6}">
                        </div>
                     </div>
                     <!--Select City-->
                     <div class="col-md-6">
                        <div class="form-group label-floating">
                           <label class="control-label"> Search For State</label>
                           <ng-select
                           placeholder="Search For State"
                           class=""
                           formControlName="state"
                           (change)="getscityList($event)">
                           <ng-option *ngFor="let state of states" [value]="state.state_code">{{
                           state.name | titlecase
                           }}</ng-option>
                           </ng-select>
                        </div>
                     </div>
                     <!--Select City-->
                     <div class="col-md-6">
                        <div class="form-group label-floating">
                           <label class="control-label"> Search For City</label>
                           <ng-select
                              placeholder="Search For City"
                              class=""
                              formControlName="city">
                              <ng-option *ngFor="let city of city_list" [value]="city">{{
                              city | titlecase
                              }}</ng-option>
                           </ng-select>
                        </div>
                     </div>
                     <!--UNID-->
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="control-label">UNID</label>
                           <input type="text" min=0 class="form-control" placeholder="Enter UNID"  formControlName="unid" onKeyPress="if(this.value.length==15) return false;">
                        </div>
                     </div>
                     <!--Area Name-->
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="control-label">Area Name</label>
                           <input type="text" min=0 class="form-control" placeholder="Enter Area"  formControlName="area_name">
                        </div>
                     </div>
                     <!--Select Lifestage-->
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="control-label">Lifestage</label>
                           <select class="form-control text-capitalize" formControlName="lifestage">
                              <option value="" selected>Select Lifestage</option>
                              <option class="text-capitalize" *ngFor="let v of lifeStage" value="{{v}}">{{v}}</option>
                           </select>
                        </div>
                     </div>
                     <!--Select Theme-->
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="control-label">Theme</label>
                           <select class="form-control text-capitalize" formControlName="theme">
                              <option value="" selected>Select Theme</option>
                              <option class="text-capitalize" *ngFor="let v of theme" value="{{v}}">{{v}}</option>
                           </select>
                        </div>
                     </div>
                     <!--Developer Name-->
                     <div class="col-md-6">
                        <div class="form-group label-floating" >
                           <label class="control-label">Developer Name</label>
                           <input type="text" min=0 class="form-control" placeholder="Enter Area"  formControlName="developer_name">
                        </div>
                     </div>
                     <div class="col-md-4">
                        <div class="form-group label-floating">
                           <label class="control-label">Start From</label>
                           <input type="number" min=0 class="form-control" placeholder="Enter Area" formControlName="start_from">
                        </div>
                     </div>
                     <div class="col-md-4">
                        <div class="form-group label-floating">
                           <label class="control-label">Apartment Value</label>
                           <input type="number" min=0 class="form-control" placeholder="Enter Area" formControlName="apartment_value">
                        </div>
                     </div>
                     <div class="col-md-4">
                        <div class="form-group label-floating">
                           <label class="control-label">Apartment Area</label>
                           <input type="number" min=0 class="form-control" placeholder="Enter Area" formControlName="area">
                        </div>
                     </div>
                     <!--Format with varient id and layout image-->
                     <div class="col-md-12">
                        <fieldset formArrayName="format"
                           >
                           <div class="row mt-3" *ngFor="let item of createApartmentForm.get('format')['controls']; let i = index;" [formGroup]="item">
                           <div class="card ml-3" style="width: 59rem !important;">
                              <div class="container-fluid">
                                 <!--Select Format-->      
                                 <div class="col-md-4 mt-3">
                                    <div class="form-group label-floating" >
                                       <label class="control-label">Select Format</label>
                                       <select class="form-control text-capitalize" formControlName="name">
                                          <option value="" selected>Select Format</option>
                                          <option class="text-capitalize" *ngFor="let v of formatData" value="{{v}}">{{v}}</option>
                                       </select>
                                    </div>
                                 </div>
                                 <!--Select Format Ends Here-->
                                 <!--Variant Data Format-->
                                 <div class="col-md-12">
                                    <div class="card mb-3" style="width: 55rem !important;">
                                       <div class="container-fluid">
                                          <fieldset formArrayName="variants">
                                             <div class="row" *ngFor="let player of item.get('variants')['controls']; let j = index;" [formGroup]="player">
                                             <div class="col-md-4">
                                                <div class="form-group label-floating" >
                                                   <label class="control-label">Variant ID</label>
                                                   <input type="text" min=0 class="form-control" placeholder="Enter Varient ID"  formControlName="variant_id" onKeyPress="if(this.value.length==6) return false;">
                                                </div>
                                             </div>
                                             <div class="col-md-4">
                                                <div class="form-group label-floating">
                                                   <label class="control-label">Select Layout Floor Plan</label>
                                                   <input type="file" (change)="onChange($event,i,j)" class="form-control border-0" name="attachment_file" formControlName="layout_image">
                                                </div>
                                             </div>
                                             <div class="col-md-4">
                                                <div class="form-group label-floating">
                                                   <label class="control-label">Select Primary</label>
                                                   <input type="file" (change)="onChangeImage($event,i,j)" class="form-control border-0" name="attachment_file" formControlName="primary_image">
                                                </div>
                                             </div>
                                       </div>
                                       </fieldset>
                                    </div>
                                 </div>
                              </div>
                              <!--Variant Data Format Ends Here-->
                              <a (click)="addAnotherVariant(item)" class="addIcon"><i class="fa fa-plus mr-1" aria-hidden="true"></i>Add Another Variant</a>
                           </div>
                     </div>
                  </div>
                  </fieldset>
               </div>
               <!--Format with varient id and layout image ends here-->
               <a (click)="pushJobAttributes(createApartmentForm)" class="addIcon ml-4 mt-3"><i class="fa fa-plus mr-1" aria-hidden="true"></i>Add Another Format</a>
            </div>
            <button type="submit" [disabled]="!createApartmentForm.valid" class="button pull-right" >Submit</button>  
            </form>
         </div>
      </div>
   </div>
</div>
</div>
</div>
<!-- </div> -->
<!-- </div> -->


// WEBPACK FOOTER //
// ./src/app/platform/organisation/add-apartment/add-apartment.component.html